// import components
import { Box, styled, BoxProps } from '@mui/material';

export const StyledHeader = styled(Box)<BoxProps>(() => ({
  zIndex: 40,
  width: '100%'
}));

export const StyledMainWrapperBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(4),
  display: 'grid',
  alignItems: 'center',
  gap: theme.spacing(4),
  gridTemplateColumns: 'repeat(auto-fit, minmax(475px, auto))',
  borderBottom: `1px solid ${theme.palette.divider}`,

  '.MuiAutocomplete-root': {
    minWidth: theme.spacing(50)
  }
}));

export const StyledHeaderLeftBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'end',
  gap: theme.spacing(6)
}));

export const StyledHeaderRightBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing(1),
  GridColumnEnd: -1
}));
